import React from 'react';
import fintegrateLogo from '../../../assets/images/fintegrateLogo.png';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    maxWidth: '100%',
    maxHeight: '100%',
    height: 'auto'
  }
});

const LogoWithText = () => {
  const classes = useStyles();
  return (
    <img className={classes.logo} src={fintegrateLogo} alt="Fintegrate Logo" />
  );
};

export default LogoWithText;
